// One weather timeline shared by every chapter, not reset by scrolling.
export const WEATHER_SEQUENCE = Object.freeze([
 {id:'sunshine',label:'Sunshine',duration:18,phase:.01,rain:0,wind:.08},
 {id:'breeze',label:'Breeze',duration:16,phase:.10,rain:0,wind:1},
 {id:'rain',label:'Rain',duration:24,phase:.67,rain:1,wind:.25}
]);
// Matches the existing tree and its canopy, in sandbox-local coordinates.
export const TREE_SHELTER = Object.freeze({x:-3.3,z:-2.4,rx:1.97,rz:1.51,roof:2.75,canopyScale:1.35});
const clamp=(v,a,b)=>Math.max(a,Math.min(b,v));
export function createWeather(saved={}){
 saved=saved&&typeof saved==='object'?saved:{};
 const index=Number.isInteger(saved.index)?clamp(saved.index,0,2):0;
 return {index,elapsed:Number.isFinite(saved.elapsed)?clamp(saved.elapsed,0,WEATHER_SEQUENCE[index].duration):0};
}
export function weatherNow(state){return WEATHER_SEQUENCE[state.index];}
export function nextWeather(state){state.index=(state.index+1)%WEATHER_SEQUENCE.length;state.elapsed=0;return weatherNow(state);}
export function updateWeather(state,dt){state.elapsed+=clamp(Number.isFinite(dt)?dt:0,0,.1);if(state.elapsed>=weatherNow(state).duration)nextWeather(state);return weatherNow(state);}
export function underCanopy(x,z,radius=0){
 const s=TREE_SHELTER,rx=s.rx-Math.max(0,radius),rz=s.rz-Math.max(0,radius);
 // Conservatively shelter the whole horizontal footprint, not just the centre.
 return rx>0&&rz>0&&((x-s.x)/rx)**2+((z-s.z)/rz)**2<=1;
}
export function isSheltered(x,z,radius=.225){return underCanopy(x,z,radius);}
export function rainUnderCanopy(x,y,z){return y<TREE_SHELTER.roof&&underCanopy(x,z,0);}
